import React from "react";
import checkeredCircle from "../Images/checkeredCircle.png";
export const CheckeredCircle = ({style}) => {

  return (
    <img
      src={checkeredCircle}
      alt="checkeredCircle"
      style={style}
    />
  );
};
